module.exports = __webpack_public_path__ + "static/media/Knowing Your Career.f993ab69.pdf";